const tabs = {
  PositionsList: () => import('@/views/recruitment/PositionsList'),
  PositionTabs: () => import('@/views/recruitment/PositionTabs')
}

const state = {
  currentTab: tabs.PositionsList,
  tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentTab = state.tabs[tab]
  }
}

const actions = {
  setTabs({ commit }, tab) {
    commit('SET_TABS', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
